export const NOT_GRADED = {
  key: 'not-graded',
  title: 'Not graded',
  color: 'lightBlue',
};

export const NOT_SUBMITTED = {
  key: 'not-submitted',
  title: 'Not submitted',
  color: 'paleRed',
};

export const LATE_SUBMISSION = {
  key: 'late-submission',
  title: 'Late submission',
  color: 'cream',
};

export const AWAITING_DECISION = {
  key: 'awaiting-decision',
  title: 'Awaiting decision',
  color: 'lavender',
};
